export default __webpack_public_path__ + "static/sonokembang-80772f03e2b8f2dde98536483355d7b9.png";